import { EPromoProductType, IPromoProduct } from '../../types/product';
import { EPromoType, IPromo } from '../../types/promosPage';

const PROMO_PRODUCT_TYPE_MAP = {
  [EPromoType.Bonus]: EPromoProductType.Bonus,
  [EPromoType.CianMortgage]: EPromoProductType.CianMortgage,
  [EPromoType.Discount]: EPromoProductType.Discount,
  [EPromoType.MaternalCapital]: EPromoProductType.MaternalCapital,
  [EPromoType.Military]: EPromoProductType.MilitaryMortgage,
  [EPromoType.Mortgage]: EPromoProductType.Mortgage,
};

export const createPromoProduct = (promo: IPromo): IPromoProduct => {
  return {
    id: promo.providerPromoId,
    offerType: 'promo',
    extra: {
      type: PROMO_PRODUCT_TYPE_MAP[promo.promoType],
    },
  };
};
